import { EMAIL_REGEX } from '../../../NonReact/constants/Regexes'
import { IsStringEmpty } from '../../../NonReact/utils/GlobalFunctions'

/**
 * Is a given Email address valid?
 *
 * @param email - The email address to check
 *
 * @returns - True if the email address is valid, false otherwise
 */
export const isEmailAddressValid = (email?: string): boolean => {
    if (IsStringEmpty(email)) {
        return false
    }

    return !!email?.match(EMAIL_REGEX)
}
